import PropTypes from 'prop-types';
import { CircleTick, WarningTriangle } from 'assets/icons';
import { ctaGreen, white } from 'constants/variables';

const Title = ({ icon, title, description, link, className }) => {
  const Icon = ({ type }) => {
    /* TODO: Add icons for other variants if required */
    const iconMap = {
      success: (
        <CircleTick
          fillColorMain={ctaGreen}
          fillColorSecondary={white}
          width={45}
          height={45}
        />
      ),
      error: <WarningTriangle width={45} height={39} />,
    };

    return iconMap[type] || null;
  };

  return (
    <div className="fl fl-col ai-c">
      <div className="fl fl-col m-fl-row ai-c jc-c">
        {icon && <Icon type={icon} />}

        <h1
          className={`ta-c ff-body fs-30 m-fs-30 lh-1 tc-main mb-0 mt-10 m-mt-0 m-ml-10${
            className ? ` ${className}` : ''
          }`}>
          {title}
        </h1>
      </div>

      {description && (
        <p className="m-width-80 ta-c fs-18 fw-400 lh-1-3 tc-secondary mt-10 mb-0">
          {description}
          {link && <a href={link.url}> {link.text}</a>}
        </p>
      )}
    </div>
  );
};

Title.propTypes = {
  icon: PropTypes.oneOf(['success', 'error']),
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  link: PropTypes.shape({ url: PropTypes.string, title: PropTypes.string }),
};

export default Title;
